import type { ReactNode } from 'react'

interface ConfirmModalProps {
  title: string
  body: ReactNode
  confirmLabel?: string
  pendingLabel?: string
  onConfirm: () => void
  onCancel: () => void
  isPending?: boolean
  error?: string | null
}

export function ConfirmModal({
  title,
  body,
  confirmLabel = 'Confirm',
  pendingLabel,
  onConfirm,
  onCancel,
  isPending = false,
  error,
}: ConfirmModalProps) {
  return (
    <div className="fixed inset-0 bg-black/40 z-[600] flex items-center justify-center">
      <div
        className="bg-surface rounded-2xl px-8 py-7 max-w-[420px] w-full"
        style={{ boxShadow: '0 8px 40px rgba(0,0,0,0.2)' }}
      >
        <h2 className="m-0 mb-2.5 text-[18px]">{title}</h2>
        <p className="m-0 mb-4 text-[14px] text-ink-2">{body}</p>
        {error && <p className="m-0 mb-4 text-[13px] text-danger">{error}</p>}
        <div className="flex gap-2.5 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-lg border border-line-soft bg-surface text-ink text-[13px] cursor-pointer font-sans"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isPending}
            className="px-4 py-2 rounded-lg border-0 text-white text-[13px] font-semibold cursor-pointer font-sans disabled:opacity-60 bg-danger"
          >
            {isPending ? (pendingLabel ?? confirmLabel) : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
